import React, { Component, Fragment } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { isEmail } from "validator";
import api from "../../../../services/api";

const ROLES_DISPONIVEIS = ["user", "moderator", "admin"];

const required = (value) => {
    if (!value) {
        return <div className="alert alert-danger" role="alert">Este campo é obrigatório!</div>;
    }
};

const email = (value) => {
    if (!isEmail(value)) {
        return <div className="alert alert-danger" role="alert">Este não é um e-mail válido.</div>;
    }
};

export default class UsuarioForm extends Component {

    constructor(props) {
        super(props);

        let modoEdicao = !!this.props.match.params.id;

        this.state = {
            modoEdicao,
            nome: "",
            username: "",
            email: "",
            password: "",
            novaSenha: "",
            unidade: "",
            roles: ["user"],
            isAutorizado: false,
            liberadoEdicao: false,
            carregando: modoEdicao,
            enviando: false,
            mensagem: "",
            sucesso: false
        };
    }

    componentDidMount() {
        if (this.state.modoEdicao) this.carregarUsuario();
    }

    carregarUsuario = async () => {
        this.setState({ carregando: true });
        try {
            let resposta = await api.get(`/admin/users/${this.props.match.params.id}`);
            let usuario = resposta.data.user;
            this.setState({
                nome: usuario.nome || "",
                username: usuario.username || "",
                email: usuario.email || "",
                unidade: usuario.unidade || "",
                roles: (usuario.roles || []).map((role) => role.name),
                isAutorizado: !!usuario.isAutorizado,
                liberadoEdicao: !!usuario.liberadoEdicao,
                carregando: false
            });
        } catch (erro) {
            this.setState({ carregando: false, mensagem: "Não foi possível carregar o usuário.", sucesso: false });
        }
    };

    onChangeCampo = (campo) => (evento) => {
        this.setState({ [campo]: evento.target.value });
    };

    onChangeIsAutorizado = (evento) => {
        this.setState({ isAutorizado: evento.target.checked });
    };

    onChangeLiberadoEdicao = (evento) => {
        this.setState({ liberadoEdicao: evento.target.checked });
    };

    onChangeRole = (role) => (evento) => {
        let roles = this.state.roles.slice();
        if (evento.target.checked) {
            if (!roles.includes(role)) roles.push(role);
        } else {
            roles = roles.filter((r) => r !== role);
        }
        this.setState({ roles });
    };

    handleSubmit = async (evento) => {
        evento.preventDefault();
        this.setState({ mensagem: "", sucesso: false });

        this.form.validateAll();
        if (this.checkBtn.context._errors.length > 0) return;

        this.setState({ enviando: true });

        try {
            if (this.state.modoEdicao) {
                await api.put(`/admin/users/${this.props.match.params.id}`, {
                    nome: this.state.nome,
                    email: this.state.email,
                    unidade: this.state.unidade,
                    roles: this.state.roles,
                    isAutorizado: this.state.isAutorizado,
                    liberadoEdicao: this.state.liberadoEdicao
                });

                if (this.state.novaSenha) {
                    await api.put(`/admin/users/${this.props.match.params.id}/senha`, {
                        senha: this.state.novaSenha
                    });
                }
            } else {
                await api.post("/admin/users", {
                    nome: this.state.nome,
                    username: this.state.username,
                    email: this.state.email,
                    password: this.state.password,
                    unidade: this.state.unidade,
                    roles: this.state.roles
                });
            }

            this.setState({ enviando: false, sucesso: true, mensagem: "Usuário salvo com sucesso." });
            setTimeout(() => this.props.history.push("/admin/usuarios"), 800);
        } catch (erro) {
            let mensagem = (erro.response && erro.response.data && erro.response.data.message) || "Não foi possível salvar o usuário.";
            this.setState({ enviando: false, sucesso: false, mensagem });
        }
    };

    render() {
        let { modoEdicao, carregando } = this.state;

        if (carregando) return <div className="content"><p>Carregando...</p></div>;

        return (
            <Fragment>
                <div className="content">
                    <div className="container">
                        <div className="col-lg-6 col-md-8 ml-auto mr-auto">
                            <div className="card card-container">
                                <div className="card-header">
                                    <h3 className="header text-center">{modoEdicao ? "Editar usuário" : "Novo usuário"}</h3>
                                </div>
                                <div className="card-body">
                                    <Form onSubmit={this.handleSubmit} ref={(c) => { this.form = c; }}>

                                        <div className="form-group">
                                            <label>Nome</label>
                                            <Input type="text" className="form-control" value={this.state.nome} onChange={this.onChangeCampo("nome")} validations={[required]} />
                                        </div>

                                        {!modoEdicao && (
                                            <div className="form-group">
                                                <label>Usuário</label>
                                                <Input type="text" className="form-control" value={this.state.username} onChange={this.onChangeCampo("username")} validations={[required]} />
                                            </div>
                                        )}

                                        <div className="form-group">
                                            <label>E-mail</label>
                                            <Input type="text" className="form-control" value={this.state.email} onChange={this.onChangeCampo("email")} validations={[required, email]} />
                                        </div>

                                        {!modoEdicao && (
                                            <div className="form-group">
                                                <label>Senha</label>
                                                <Input type="password" className="form-control" value={this.state.password} onChange={this.onChangeCampo("password")} validations={[required]} />
                                            </div>
                                        )}

                                        {modoEdicao && (
                                            <div className="form-group">
                                                <label>Nova senha</label>
                                                <Input type="password" className="form-control" placeholder="Deixe em branco para não alterar" value={this.state.novaSenha} onChange={this.onChangeCampo("novaSenha")} />
                                            </div>
                                        )}

                                        <div className="form-group">
                                            <label>Unidade</label>
                                            <select className="form-control" value={this.state.unidade} onChange={this.onChangeCampo("unidade")} required>
                                                <option value="" hidden>Selecione uma unidade</option>
                                                <option value="CEP PROF. STÊNIO LOPES">Centro de Formação Profissional Prof. Stenio Lopes (SL)</option>
                                                <option value="CEP ODILON RIBEIRO COUTINHO">Centro de Formação Profissional Odilon Ribeiro Coutinho (ORC)</option>
                                                <option value="CEP JOSÉ WILLIAM LEMOS LEAL">Centro de Formação Profissional José William Lemos Leal (JWLL)</option>
                                                <option value="CTCC ALBANO FRANCO">Centro de Formação Profissional e Instituto SENAI de Tecnologia do Couro e do Calçado Albano Franco (CTCC)</option>
                                                <option value="CITI/CAM CENTRO DE INOV. E TEC. INDUSTRIAL">CITI/CAM CENTRO DE INOV. E TEC. INDUSTRIAL (CITI/CAM)</option>
                                                <option value="CFP MIRIAM BENEVIDES GADELHA">Centro de Formação Profissional Miriam Benevides Gadelha (MBG)</option>
                                                {/* ISTAI fica de fora — decisão do usuário (2026-08-24), ver docs/PLANO_ITEM8_CONSTANTES.md */}
                                                <option value="IST TÊXTIL E CONFECÇÕES">Instituto SENAI de Tecnologia Têxtil e Confecções (ISTTC)</option>
                                                <option value="IST EFICIÊNCIA OPERACIONAL">IST Eficiência Operacional (ISTEO)</option>
                                                <option value="FACULDADE SENAI">FACULDADE SENAI</option>
                                                <option value="ROBSON BRAGA DE ANDRADE">Robson Braga de Andrade (RBA)</option>
                                            </select>
                                        </div>

                                        <div className="form-group">
                                            <label>Funções</label>
                                            {ROLES_DISPONIVEIS.map((role) => (
                                                <div className="form-check" key={role}>
                                                    <label className="form-check-label">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            checked={this.state.roles.includes(role)}
                                                            onChange={this.onChangeRole(role)}
                                                        />
                                                        {role}
                                                        <span className="form-check-sign"></span>
                                                    </label>
                                                </div>
                                            ))}
                                        </div>

                                        {modoEdicao && (
                                            <div className="form-group">
                                                <div className="form-check">
                                                    <label className="form-check-label">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            checked={this.state.isAutorizado}
                                                            onChange={this.onChangeIsAutorizado}
                                                        />
                                                        Autorizado a acessar o sistema
                                                        <span className="form-check-sign"></span>
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <label className="form-check-label">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            checked={this.state.liberadoEdicao}
                                                            onChange={this.onChangeLiberadoEdicao}
                                                        />
                                                        Liberado para editar mesmo fora do prazo
                                                        <span className="form-check-sign"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        )}

                                        {this.state.mensagem && (
                                            <div className="form-group">
                                                <div className={this.state.sucesso ? "alert alert-success" : "alert alert-danger"} role="alert">
                                                    {this.state.mensagem}
                                                </div>
                                            </div>
                                        )}

                                        <div className="form-group">
                                            <button className="btn btn-primary btn-block" disabled={this.state.enviando}>Salvar</button>
                                        </div>

                                        <CheckButton style={{ display: "none" }} ref={(c) => { this.checkBtn = c; }} />
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
